import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Reply = ({
  size,
  type,
  theme,
  className,
  dataTestId = "reply-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M6.74306 3.39947C7.00453 3.14024 7.00634 2.71813 6.74712 2.45667C6.48789 2.1952 6.06578 2.19339 5.80432 2.45262L2.02444 6.20013C1.89818 6.32532 1.82715 6.49575 1.82715 6.67356C1.82715 6.85136 1.89818 7.0218 2.02444 7.14698L5.80432 10.8945C6.06578 11.1537 6.48789 11.1519 6.74712 10.8904C7.00634 10.629 7.00453 10.2069 6.74306 9.94765L4.11244 7.33954H10.1734C11.6462 7.33954 12.8401 8.53345 12.8401 10.0062V13.0745C12.8401 13.4427 13.1386 13.7411 13.5068 13.7411C13.875 13.7411 14.1734 13.4427 14.1734 13.0745V10.0062C14.1734 7.79707 12.3826 6.00621 10.1734 6.00621L4.11381 6.00621L6.74306 3.39947Z" />
  </SVGIcon>
);
